import { CREATE_USERS, DELETE_USERS, GET_ALL_USERS, GET_ID_USERS, SEARCH_USERS, UPDATE_USERS } from '@/types/usersTypes';

const actionTypes = [
    { type: CREATE_USERS, key: 'createUsers' },
    { type: DELETE_USERS, key: 'deleteUsers' },
    { type: GET_ALL_USERS, key: 'getAllUsers' },
    { type: GET_ID_USERS, key: 'getIdUsers' },
    { type: SEARCH_USERS, key: 'searchUsers' },
    { type: UPDATE_USERS, key: 'updateUsers' }
];

let initialState = actionTypes.reduce((acc, { key }) => {
    acc[key] = false;
    acc[`err${key.charAt(0).toUpperCase() + key.slice(1)}`] = false;
    return acc;
}, {});

const userSlice = (state = initialState, action) => {
    const acc = actionTypes.find((item) => item.type === action.type);
    if (!acc) return state;
    return {
        ...state,
        [acc.key]: action?.payload?.data,
        [`err${acc.key.charAt(0).toUpperCase() + acc.key.slice(1)}`]: action?.payload?.errorMessage
    };
};

export default userSlice;
